// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fetchUserPersonalization } from '@jira/platform__services-personalization/src/services/user/index.tsx';
import {
	createResource,
	useResource,
	type ResourceStoreContext,
	type RouterDataContext,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import {
	ANALYTICS_ID,
	RESOURCE_KEY,
	RESOURCE_TYPE,
} from './FetchAtlassianAccountTraitsResourceType.constants.tsx';
import type { PersonalizationApiTraitData } from './PersonalizationApiTraitData.types.tsx';

const getData = async (
	_: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<PersonalizationApiTraitData[] | null> => {
	try {
		if (tenantContext.isAnonymous || !tenantContext.atlassianAccountId) {
			return null;
		}

		const accountId = tenantContext.atlassianAccountId;
		const response = await fetchUserPersonalization({ userId: accountId });

		return response ?? null;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: ANALYTICS_ID,
				packageName: 'jiraProjectPagesContextualSummary',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}

	return null;
};

export const fetchAtlassianAccountTraitsResource: RouteResource<
	PersonalizationApiTraitData[] | null
> = createResource<PersonalizationApiTraitData[] | null>({
	type: RESOURCE_TYPE,
	getKey: () => RESOURCE_KEY,
	getData,
	maxAge: Number.MAX_VALUE,
	isCritical: true,
});

export const useFetchAtlassianAccountTraitsResource = (): UseResourceHookResponse<
	PersonalizationApiTraitData[] | null
> => useResource(fetchAtlassianAccountTraitsResource);
